export default function (cli) {
  return {
    adminShopList (offset, params = {}) {
      // 管理ユーザ用店舗一覧取得
      if (!params['limit']) {
        params['limit'] = cli.getPageSize()
      }
      if (offset) {
        params['offset'] = offset
      }
      return cli.get(`${cli.adminApiEndpoint}shops/`).query(params)
    },

    list () {
      return cli.get(`${cli.apiEndpoint}shops/`)
    },

    all (fn) {
      let shops = []
      let request = url => {
        return cli.get(url).then(res => {
          shops = shops.concat(res.body.results)
          if (res.body.next) {
            return request(res.body.next)
          } else {
            return shops
          }
        })
      }
      return request(`${cli.adminApiEndpoint}shops/`).then(fn)
    },

    detail (shopPk) {
      return cli.get(`${cli.apiEndpoint}shops/${shopPk}/`)
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/shops.js